<template>
  <div>
    <!--v-for="(name, index) in company_names.reverse()" :key="index" :id="'el-' + (index + 1)"-->
    <div id="el-one" class="el-card" style="display: flex; justify-content: center;align-items: center;
      width: 220px;height: 210px;border: 1px solid gainsboro;" @click="goToDeviceManagement()">
      <div class="DSFZ" v-if="loginInfo.username === 'dsfz'"><el-button id="all-button"></el-button></div>
      <div class="MWSP" v-else-if="loginInfo.username === 'mwsp'"><el-button id="all-button"></el-button></div>
      <div class="NFZY" v-else-if="loginInfo.username === 'nfzy'"><el-button id="all-button"></el-button></div>
      <div class="JPJB" v-else-if="loginInfo.username === 'jpjb'"><el-button id="all-button"></el-button></div>
      <div class="GHZY" v-else-if="loginInfo.username === 'ghzy'"><el-button id="all-button"></el-button></div>
      <div class="HFNMKJ" v-else-if="loginInfo.username === 'hfnmkj'"><el-button id="all-button"></el-button></div>
      <div class="SJJY" v-else-if="loginInfo.username === 'sjjy'"><el-button id="all-button"></el-button></div>
      <div class="HFBH" v-else-if="loginInfo.username === 'hfbh'"><el-button id="all-button"></el-button></div>
      <div class="HFBHYFZHT" v-else-if="loginInfo.username === 'hfbhyfzht'"><el-button id="all-button"></el-button></div>
      <span style="font-size: 15px;position: absolute;top: 180px;color: green">{{ displayedCompanyName }}</span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "UserHome",
  data(){
    return{
      companies: [], // 存储公司信息的数组
      loginInfo: {}, // 用于存储登录账号信息
      displayedCompanyName: '', // 显示的公司名称
    }
  },
  methods:{
    // 根据企业id 去查到 企业id相关的设备表面参数
    goToDeviceManagement() {
      const company_id = this.$route.query.com_id;
      console.log('这里是UserHome'+company_id)
      this.$router.push({
        path:'/menu/card', // 路径
        query:{ com_id : company_id }, //查询参数
      })
      // 这里可能需要发送异步请求获取其他数据，暂时保留你的代码
      axios.get('/otherApi/manager/getallcompanysensor/', {
        params: {
          company_id: company_id,
        }
      }).then(res => {
        console.log("userHome的res中"+JSON.stringify(res.data.data));
        if (this.$route.path !== '/menu/userCard') {
          this.$router.push({path:'/menu/userCard',query:company_id});
        }
      }).catch(error => {
        console.error('Error fetching company id:', error);
      });
    },
    //拿到企业的名称
    getCompanies() {
      axios.get('/otherApi/manager/getallcompany/')
        .then(res => {
          this.companies = res.data.data;
          this.updateDisplayedCompanyName();
        })
        .catch(error => {
          console.error('Error fetching company information:', error);
        });
    },

    // 根据 loginInfo.username 更新显示的公司名称
    updateDisplayedCompanyName() {
      const prefix = this.loginInfo.username.toUpperCase() + '_HF0410';
      const company = this.companies.find(company => company.company_id.startsWith(prefix));
      this.displayedCompanyName = company ? company.company_name : '';
    },
  },
  mounted() {
    this.getCompanies();
    this.loginInfo = JSON.parse(localStorage.getItem('user')); // 从 localStorage 中获取登录账号信息
    this.updateDisplayedCompanyName();
  },
  created() {
    //const com_id = this.$route.query.com_id;
    const company_id = this.$route.query.com_id;
    //console.log(this.$route.query)
    console.log('*********************'+company_id)
  }
}
</script>

<style scoped>
#el-one{
  position: absolute;
  top: 120px;
  left: -60px;
}
.DSFZ{
  background-image: url("../assets/img/img_16.png");
  background-size: 300px;
  width: 300px;
  height: 600px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  left: -35px;
  cursor: pointer;
}
.MWSP{
  background-image: url("../assets/img/img_21.png");
  background-size: 280px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  left: -25px;
  cursor: pointer;
}
.NFZY{
  background-image: url("../assets/img/img_22.png");
  background-size: 280px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 1px;
  left: -20px;
  cursor: pointer;
}
.JPJB{
  background-image: url("../assets/img/img_17.png");
  background-size: 270px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: -10px;
  left: -25px;
  cursor: pointer;
}
.GHZY{
  background-image: url("../assets/img/img_23.png");
  background-size: 240px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 30px;
  left: 0px;
  cursor: pointer;
}
.HFNMKJ{
  background-image: url("../assets/img/img_24.png");
  background-size: 220px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 30px;
  left: 0px;
  cursor: pointer;
}
.SJJY{
  background-image: url("../assets/img/img_25.png");
  background-size: 300px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  left: -25px;
  cursor: pointer;
}
.HFBH{
  background-image: url("../assets/img/img_26.png");
  background-size: 240px;
  width: 400px;
  height: 500px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  left: -10px;
  cursor: pointer;
}
.HFBHYFZHT{
  background-image: url("../assets/img/img_27.png");
  background-size: 300px;
  width: 220px;
  height: 220px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0px;
  left: -1px;
  cursor: pointer;
}
#all-button{
  width: 80px;
  height: 80px;
  opacity: 0;
  margin-left: -8px;
  margin-top: -5px;
}
</style>



// WEBPACK FOOTER //
// src/components/UserHome.vue